import { z } from 'zod';

export const LeadInputSchema = z
  .object({
    tool_id: z.string().uuid(),
    session_id: z.string().uuid(),
    name: z.string().min(1).max(200).optional(),
    email: z.string().email().optional(),
    phone: z.string().min(7).max(32).optional(),
    intent_stage: z.string().optional(),
    geo_country: z.string().length(2).optional(),
    geo_region: z.string().optional(),
    geo_city: z.string().optional(),
    geo_zip: z.string().optional(),
    property_type: z.string().optional(),
    estimated_value_cents: z.number().int().nonnegative().optional(),
    timeline: z.string().optional(),
    tool_output: z.record(z.unknown()).default({}),
  })
  .refine((d) => Boolean(d.email || d.phone), {
    message: 'Either email or phone is required',
    path: ['email'],
  });
export type LeadInput = z.infer<typeof LeadInputSchema>;
